import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '../../_services/auth/authentication.service';
// import {Authentication, Token} from '../../_model/auth/authentication.model';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Authentication, Token } from '../../_model/auth/authentication.model';
import { PenggunaChangePasswordModel, PenggunaChangePasswordUserModel } from '../../_model/user-management/pengguna.model';
import { GlobalService } from '../../_services/global.service';
import { UmPenggunaService } from '../user-management/um-pengguna/um-pengguna.service';

declare var require;
const Swal = require('sweetalert2');
@Component({
  selector: 'app-login',
  templateUrl: 'login.component.html',
  styleUrls: ['login.component.scss']
})
export class LoginComponent implements OnInit {
  @ViewChild('content') modalContent: any;
  @ViewChild('contentGeneratePassword') modalContentGeneratePassword: any;
  public newUser = false;
  private user: Authentication;
  formGroup: FormGroup;
  listTahunAnngaran: string[] = [];
  captchaValue = '';
  submitted = false;
  public tahunAnggaran = 'tahunAnggaran';
  formChangePassword: FormGroup;
  showLoader = false;
  password: string;
  currentMonth: any;
  lastMonth: any;
  year: any = new Date().getFullYear();
  sandiFieldType: string = 'password'; // Track the input field type (password/text)

  constructor(
    private router: Router,
    private _formBuilder: FormBuilder,
    private _authService: AuthenticationService,
    private _globalService: GlobalService,
    private _auth: AuthenticationService,
    private _modalService: NgbModal,
    private _router: Router,
    private _service: UmPenggunaService,
    private _toastr: ToastrService) {
  }

  ngOnInit(): void {
    this.user = {} as Authentication;
    localStorage.removeItem('currentUser');
    localStorage.removeItem('tahunAnggaran');
    this.findTahunAnggaran();
    // this.makeCaptcha();
    this.randomCaptcha(5)
    this.formGroup = this._formBuilder.group({
      username: this._formBuilder.control('', [Validators.required]),
      password: this._formBuilder.control('', [Validators.required]),
      tahunAnggaran: this._formBuilder.control('', [Validators.required]),
      // captcha: this._formBuilder.control('', [Validators.required, this.validateMatch()]),
      captcha: this._formBuilder.control('', [Validators.required]),
    });
    this.formChangePassword = this._formBuilder.group({
      nrk: this._formBuilder.control('', [Validators.required]),
      sandiLama: this._formBuilder.control('', [Validators.required]),
      sandiBaru: this._formBuilder.control('', [Validators.required,
        Validators.minLength(8), 
        Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/)]),
      konfirmasiSandiBaru: this._formBuilder.control('', [Validators.required,
        Validators.minLength(8), 
        Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/)]),
    },{ validator: this.passwordsMatchValidator});
    const currentMonth = (new Date().getMonth() + 1).toString().padStart(2, '0');
    this.currentMonth = currentMonth;
    console.log("BULAN INI", currentMonth);

  }

  findTahunAnggaran() {
    this._globalService.getTahunAnggaran().subscribe((response: any) => {
      console.log('Response Tahun Anggaran');
      console.log(response);
      if (response.status === 200) {
        this.listTahunAnngaran = response.body;
      }
    });
  }

  findBulanLogin() {
    this._globalService.getBulanLoginUser(this.formGroup.get('username').value).subscribe((response: any) => {
      console.log('Response Bulan Login');
      console.log(response);
      if (response.status === 200) {
        this.lastMonth = response.body.bulan;
      }
      console.log('Bulan Terakhir', this.lastMonth);
    });
  }



  randomCaptcha(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < 6; i++) {
      result += characters.charAt(Math.floor(Math.random() *
        charactersLength));
    }
    if (this.captchaValue) {
      this.formGroup.controls['captcha'].setErrors({ 'match': true });
    }
    this.captchaValue = result;
  }

  checkCaptcha(): boolean {
    return !((this.formGroup.get('captcha').value === this.captchaValue) && this.formGroup.get('captcha').value.length >= 5);
  }

  // validateMatch(): ValidatorFn {
  //   return (control: AbstractControl): ValidationErrors | null => {
  //     if (control.value !== this.captchaValue) {
  //       return {'match': true};
  //     }
  //     return null;
  //   };
  // }

  openModalGantiPass() {
    this._modalService.open(this.modalContent, {
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
  }
  openModalGeneratePass() {
    this._modalService.open(this.modalContentGeneratePassword, {
      windowClass: 'custom-modal',
      centered: true,
    });
  }

  closeModalGantiPass() {
    this._modalService.dismissAll();
  }

  login() {
    this.submitted = true;
    this.showLoader = true;
    this.user = this.formGroup.value;
    this.findBulanLogin();

    if (!this.formGroup.valid) {
      this._toastr.error('Gagal', 'Silahkan lengkapi isian login!');
      this.showLoader = false;
      return;
    }
    if (this.formGroup.get('captcha').value !== this.captchaValue) {
      this._toastr.error('Gagal', 'Kode Captcha Tidak Sesuai!');
      this.showLoader = false;
      return;
    }
    // this.openModalGantiPass();
    this._authService.login(this.user).subscribe(response => {
      this.showLoader = false;
      if (response.status === 200 && this.formGroup.get('tahunAnggaran').value === '2024' || this.formGroup.get('tahunAnggaran').value === '2025' || (this.formGroup.get('username').value === 'ADMIN-TDI' || this.formGroup.get('username').value === 'PKNEGERI-1010112' || this.formGroup.get('username').value === 'PANEGERI01' || this.formGroup.get('username').value === 'TUNEGERI01' || this.formGroup.get('username').value === 'SUDIN01')) {
        const token: Token = response.body;
        this._authService.setToken(token);
        localStorage.setItem(this.tahunAnggaran, this.formGroup.get('tahunAnggaran').value);
        this.router.navigate(['/landingpage']);

      }
      // else if ((response.status === 200 && (this.user.password === '123456' || this.user.password === '1123123')) || (response.status === 200 && (this.lastMonth !== null && this.lastMonth !== this.currentMonth))) {
      //   this.openModalGeneratePass();
      //   localStorage.setItem('bulanLalu', this.currentMonth.toString());
      //   const token: Token = response.body;
      //   this._authService.setToken(token);
      //   this.formChangePassword = this._formBuilder.group({
      //     id: JSON.parse(localStorage.getItem('currentUser')).pengguna.id,
      //     sandi: this._formBuilder.control(null),
      //     konfirmasiSandi: this._formBuilder.control(null)
      //   });
      //   return;
      // }
      const token: Token = response.body;
      this._authService.setToken(token);
      localStorage.setItem(this.tahunAnggaran, this.formGroup.get('tahunAnggaran').value);
      this.router.navigate(['/landingpage']);
    }, error => {
      this.showLoader = false;
      if (error.status === 400) {
        this._toastr.error('Gagal Login', 'Username atau Password Salah!');
      }
      console.log(error);
    });

  }

  changePasswordLamaAlert() {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons.fire({
      title: 'Anda Yakin',
      text: 'Ubah Password?',
      type: 'error',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'Ya',
      cancelButtonText: 'Tidak',
      reverseButtons: true
    }).then((result) => {
      if (result.value) {
        if (this.formChangePassword.invalid) {
          Swal.fire('Ada data yang belum diisi');
        } else {
          console.log(this.formChangePassword.value);
          console.log(this.user);
          this.user.username = this.formChangePassword.value.nrk;
          this.user.password = this.formChangePassword.value.sandiLama;
          console.log(this.user);
          this._authService.login(this.user).subscribe(response => {
          if (response.status === 200 ) {
            const token: Token = response.body;
            this._authService.setToken(token);
            localStorage.setItem(this.tahunAnggaran, this.formGroup.get('tahunAnggaran').value);
            const value: PenggunaChangePasswordUserModel = this.formChangePassword.value;
            this._service.changePasswordLama(value).subscribe((response: any) => {
              if (response.status === 200) {
              this._globalService.updateBulanResetPassword(this.formChangePassword.value.nrk, this.currentMonth)
                .subscribe((response: any) => {
                  console.log('UPDATE BULAN', response);
                  if (response > 0) {
                    Swal.fire('Password berhasil disimpan, silahkan login');
                    this.logout();
                    this._modalService.dismissAll();
                    this._router.navigate(['/login']);
                  } else {
                    this._toastr.error('Gagal', response.message || 'Gagal update bulan!');
                    this.refresh();
                  }
                }, error => {
                  console.error('Error:', error);
                  this._toastr.error('Gagal', 'Terjadi kesalahan saat update bulan!');
                  this.refresh();
                });
              }
            },respError => {
              if (respError.status === 404) {
                Swal.fire(respError.error.message);
              } else {
                Swal.fire('Terjadi Kesalahan Server');
                this.logout();
                this._modalService.dismissAll();
                this._router.navigate(['/login']);
              }
            });
          }
          },error => {
            this.showLoader = false;
            if (error.status === 400) {
              this._toastr.error('Gagal Verifikasi Login Lama', 'NRK atau Password Lama Salah!');
            }
            console.log(error);
          });
        }
      }
    });
  }

  logout() {
    if (this._auth.isAuthenticated()) {
      localStorage.removeItem('currentUser');
      location.reload();
      window.localStorage.clear();
    } else {
      this._router.navigate(['/login']);
    }
  }

  refresh() {
    localStorage.removeItem('currentUser');
    window.localStorage.clear();
  }
  randomPassword(length = 8) {
    let result = '';
    const characters = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    this.password = result;
    this.formChangePassword.patchValue({
      sandi: this.password,
      konfirmasiSandi: this.password
    });
  }
  togglePasswordVisibility() {
    this.sandiFieldType = this.sandiFieldType === 'password' ? 'text' : 'password';
    const sandiInput = document.getElementById('sandi') as HTMLInputElement;
    sandiInput.type = this.sandiFieldType;
  }

  copyToClipboard() {
    const passwordValue = this.formChangePassword.get('sandi')?.value; // Adjust based on your form control
    if (passwordValue) {
      navigator.clipboard.writeText(passwordValue).then(() => {
        this._toastr.success('Password Sudah Di Salin!', 'Berhasil');
      }).catch(err => {
        console.error('Tidak Bisa Salin Password: ', err);
        this._toastr.error('Password Tidak Bisa Di Salin.', 'Gagal');
      });
    } else {
      this._toastr.warning('Password Kosong!', 'Warning');
    }
  }

  passwordsMatchValidator(control: AbstractControl) {
    const password = control.get('sandiBaru')?.value;
    const confirmPassword = control.get('konfirmasiSandiBaru')?.value;
    
    if (password && confirmPassword && password !== confirmPassword) {
      control.get('konfirmasiSandiBaru')?.setErrors({ notMatch: true });
    } else {
      control.get('konfirmasiSandiBaru')?.setErrors(null);
    }
  }

}
